export enum MicroFrontends {
  HOME,
  CATALOG,
  OMS_MODULE,
  VIDEO_COMMERCE,
  STORE_ONBOARDING,
  ANALYTICS,
  WEBSITE_APPEARANCE,
  PERFORMANCE_MARKETING,
  PAYMENTS,
  STORE_TIMINGS,
  STORE_POLICIES,
  BUSINESS_DETAILS,
  PROFILE,
  DELIVERY_SETTINGS,
  OFFERS,
  CUSTOM_DOMAIN,
  GOOGLE_ANALYTICS,
  USER_MANAGEMENT,
  SEO,
  RETURN_SETTINGS,
  SETTINGS,
  MARKETING_AUTOMATION,
  REVIEWS,
  REVIEW_SETTINGS,
  CONNECTIONS
}

export const MicroFrontendSubModules = {
  [MicroFrontends.CATALOG]: {
    PRODUCTS: "PRODUCTS",
    CATEGORIES: "CATEGORIES",
    COLLECTIONS: "COLLECTIONS",
  },
  [MicroFrontends.OMS_MODULE]: {
    ALL_ORDERS: "ALL_ORDERS",
    RETURNS: "RETURNS",
  },
  [MicroFrontends.ANALYTICS]: {
    SALES_AND_ORDERS: "SALES_AND_ORDERS",
    TRAFFIC: "TRAFFIC",
    OPERATIONS: "OPERATIONS",
    ORDERS: "ORDERS",
    OFFERS: "OFFERS",
    SALES: "SALES",
    RETURNS: "RETURNS",
    CUSTOMER_DETAILS: "CUSTOMER_DETAILS",
    CUSTOMER_SEGMENTS: "CUSTOMER_SEGMENTS",
    REPORTS: "REPORTS"
  },
  [MicroFrontends.REVIEWS]: {
    MANAGE: "MANAGE",
  },
};
